export default __webpack_public_path__ + "static/media/blessedsoul.eb936b23.png";